import './chunk-17755bd7.js';
import './chunk-8716473c.js';
import './chunk-5160dcda.js';
import './chunk-dc90942e.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { P as Pagination } from './chunk-89798991.js';
export { P as Pagination } from './chunk-89798991.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Pagination);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/pagination.js
// module id = 242
// module chunks = 0